import React from 'react';

const SkillsSection = ({ theme }) => {
  const skillCategories = [
    {
      title: "Front-End",
      skills: ["React", "TypeScript", "Vue", "JavaScript (ES6+)", "HTML", "CSS", "Tailwind", "Bootstrap", "Sass", "jQuery"]
    },
    {
      title: "Back-End",
      skills: ["PHP", "Laravel", "CodeIgniter", "MySQL", "PHPUnit", "JWT"]
    },
    {
      title: "Testing & Optimization",
      skills: ["A/B Testing", "VWO"]
    },
    {
      title: "Cloud & DevOps",
      skills: ["AWS (SQS, Lambda, Athena)", "Docker", "Jenkins", "GitHub Actions"]
    },
    {
      title: "Collaboration & Workflow",
      skills: ["Git Version Control", "GitHub", "JIRA", "Scrum", "Figma", "InVision"]
    }
  ];

  return (
    <section className="relative max-w-[2000px] mx-auto">
      <div 
        className={`
          relative px-10 py-24 mx-auto
          ${theme === 'dark' 
            ? 'bg-black' 
            : 'bg-gradient-to-b from-[#c0dfd9] to-white'
          }
        `}
        id="skills"
      >
        <div className="text-center mb-12">
          <h1 className={`
            font-['Rubik'] mb-2 font-black text-4xl lg:text-5xl
            ${theme === 'dark' ? 'text-[#f7f7f7]' : 'text-[#3b3a36]'}
          `}>
            Technical Skills
          </h1>
        </div>

        <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3 max-w-6xl mx-auto">
          {skillCategories.map((category, index) => (
            <div 
              key={index}
              className={`
                rounded-xl p-6 transition-all duration-300
                ${theme === 'dark' 
                  ? 'bg-gray-900 shadow-[5px_4px_10px_rgba(247,247,247,0.1)]' 
                  : 'bg-white shadow-[0px_5px_10px_#b3c2bf]'
                }
              `}
            >
              <h3 className={`
                font-['Rubik'] text-xl font-bold mb-4
                ${theme === 'dark' ? 'text-[#f7f7f7]' : 'text-[#3b3a36]'}
              `}>
                {category.title}
              </h3>
              
              <div className="flex flex-wrap gap-2">
                {category.skills.map((skill, skillIndex) => (
                  <span
                    key={skillIndex}
                    className={`
                      px-3 py-1.5 text-sm font-['Roboto_Mono'] rounded-full transition-all duration-200
                      ${theme === 'dark' 
                        ? 'bg-gray-800 text-[#f7f7f7] border border-gray-700' 
                        : 'bg-gray-100 text-[#3b3a36] border border-gray-200'
                      }
                    `}
                  >
                    {skill}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SkillsSection;